// examConstants.js — COPY of backend/src/constants.js
// Keep in sync! Validate with: scripts/validate-constants.js

export const EXAM_ERRORS = {
  SESSION_NOT_FOUND:      { status: 404, error: 'Session not found' },
  SESSION_EXPIRED:        { status: 410, error: 'Session has expired' },
  HEARTBEAT_STALE:        { status: 403, error: 'Heartbeat validation failed' },
  SEB_INVALID:            { status: 403, error: 'SEB validation failed' },
  IP_MISMATCH:            { status: 403, error: 'IP address not allowed' },
  ANSWER_INVALID:         { status: 400, error: 'Invalid answer format' },
  EXAM_ALREADY_SUBMITTED: { status: 409, error: 'Exam already submitted' },
  RATE_LIMITED:           { status: 429, error: 'Rate limit exceeded, retry later' },
  CHALLENGE_INVALID:      { status: 403, error: 'Challenge-response validation failed' },
  BROWSER_NOT_ALLOWED:    { status: 403, error: 'Browser access not allowed for this exam' },
  TOKEN_MISSING:          { status: 401, error: 'Authorization header missing' },
};

export const EVENT_TYPES = [
  'heartbeat_missed', 'focus_lost', 'focus_regained', 'tab_switch',
  'copy_attempt', 'paste_attempt', 'devtools_attempt', 'screenshot_attempt',
  'process_detected', 'external_display', 'vm_detected', 'ip_mismatch',
  'seb_invalid', 'session_resumed', 'server_restart',
];

export const HEARTBEAT = {
  INTERVAL_MS: 10000,
  TIMEOUT_MS: 30000,
};

// Dutch user-facing error messages (mapped from English error codes)
export const ERROR_MESSAGES_NL = {
  'Session not found': 'Sessie niet gevonden. Probeer opnieuw in te loggen.',
  'Session has expired': 'Je sessie is verlopen.',
  'Heartbeat validation failed': 'Verbinding met server verloren. Herstart de app.',
  'SEB validation failed': 'Beveiligingscontrole mislukt. Herstart de app.',
  'IP address not allowed': 'Deze toets is alleen beschikbaar op het schoolnetwerk.',
  'Invalid answer format': 'Ongeldig antwoord. Probeer opnieuw.',
  'Exam already submitted': 'Je toets is al ingeleverd.',
  'Rate limit exceeded, retry later': 'Te veel verzoeken. Wacht even en probeer opnieuw.',
  'Challenge-response validation failed': 'Beveiligingscontrole mislukt. Herstart de app.',
  'Browser access not allowed for this exam': 'Deze toets is alleen beschikbaar via de TestWisely Secure app. Vraag je docent om de installatielink.',
  'Authorization header missing': 'Niet ingelogd. Log opnieuw in.',
};

/**
 * Get Dutch error message for an API error response.
 */
export function getDutchError(englishError) {
  return ERROR_MESSAGES_NL[englishError] || 'Er is een fout opgetreden. Probeer opnieuw.';
}
